import FormFileContentField from "components/Environment/components/FormItems/FileContentField";
import Button from "ds/components/Button";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerCloseIcon from "ds/components/Drawer/CloseIcon";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/Drawer/HeaderTitle";

import styles from "./styles.module.css";

type MountedFileDrawerProps = {
  name: string;
  onDrawerClose: () => void;
  onSave: () => void;
  isEditing?: boolean;
};

const ContextMountedFilesContentDrawer = ({
  name,
  onDrawerClose,
  onSave,
  isEditing,
}: MountedFileDrawerProps) => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title={isEditing ? "Edit file" : "Create file manually"} />
        <DrawerCloseIcon handleCloseDrawer={onDrawerClose} />
      </DrawerHeader>
      <DrawerBody noPadding>
        <FormFileContentField name={name} className={styles.fileContent} />

        <DrawerFooter>
          <DrawerFooterActions>
            <Button variant="secondary" onPress={onDrawerClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" onPress={onSave}>
              {isEditing ? "Save" : "Add"}
            </Button>
          </DrawerFooterActions>
        </DrawerFooter>
      </DrawerBody>
    </>
  );
};

export default ContextMountedFilesContentDrawer;
